import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { clearForm, editProductField } from 'redux/modules/products';
import Slider from 'material-ui/Slider';
import Checkbox from 'material-ui/Checkbox';
import TextField from 'material-ui/TextField';
import Popover from 'material-ui/Popover';
import { Tooltip } from 'components';
import * as styles from './PackageManager.scss';
var NewProductForm = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme,
    newProduct: state.products.newProduct || null,
    invalidFields: state.products.invalidFields
  };
}, {
  clearForm: clearForm,
  editProductField: editProductField
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewProductForm, _Component);

  var _super = _createSuper(NewProductForm);

  function NewProductForm() {
    var _this;

    _classCallCheck(this, NewProductForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      monthlyEntryPopover: false,
      monthlyPopoverAnchor: null,
      monthlyPopoverData: {},
      setupEntryPopover: false,
      setupPopoverAnchor: null,
      setupPopoverData: {}
    });

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", function (amount) {
      var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var amountInDollars = cents ? amount / 100.0 : amount;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(Math.max(0, amountInDollars));
    });

    _defineProperty(_assertThisInitialized(_this), "handleTextFieldChange", function (e) {
      var isStringField = e.target.id === 'title' || e.target.id === 'description';

      if (e.target.id === 'retailSetupFee') {
        if (_.round(e.target.value, 2) < _this.props.newProduct.setupFeeApplicationFee) {
          var _this$props$newProduc = _this.props.newProduct,
              retailSetupFee = _this$props$newProduc.retailSetupFee,
              setupSliderRatio = _this$props$newProduc.setupSliderRatio;

          var _this$props$doFeeCalc = _this.props.doFeeCalculations(retailSetupFee, setupSliderRatio),
              likeablelocalAmount = _this$props$doFeeCalc.likeablelocalAmount;

          _this.props.editProductField('setupFeeApplicationFee', likeablelocalAmount);
        }
      }

      if (e.target.id === 'retailMonthlyPrice') {
        if (_.round(e.target.value, 2) < _this.props.newProduct.monthlyPriceApplicationFee) {
          var _this$props$newProduc2 = _this.props.newProduct,
              retailMonthlyPrice = _this$props$newProduc2.retailMonthlyPrice,
              monthlySliderRatio = _this$props$newProduc2.monthlySliderRatio;

          var _this$props$doFeeCalc2 = _this.props.doFeeCalculations(retailMonthlyPrice, monthlySliderRatio),
              _likeablelocalAmount = _this$props$doFeeCalc2.likeablelocalAmount;

          _this.props.editProductField('monthlyPriceApplicationFee', _likeablelocalAmount);
        }
      }

      _this.props.editProductField(e.target.id, isStringField ? e.target.value : _.round(e.target.value, 2) > 0 ? _.round(e.target.value, 2) : e.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMonthlySliderDrop", function () {
      var _this$props$newProduc3 = _this.props.newProduct,
          retailMonthlyPrice = _this$props$newProduc3.retailMonthlyPrice,
          monthlySliderRatio = _this$props$newProduc3.monthlySliderRatio;

      var _this$props$doFeeCalc3 = _this.props.doFeeCalculations(retailMonthlyPrice, monthlySliderRatio),
          likeablelocalAmount = _this$props$doFeeCalc3.likeablelocalAmount;

      _this.props.editProductField('monthlyPriceApplicationFee', likeablelocalAmount);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSetupSliderDrop", function () {
      var _this$props$newProduc4 = _this.props.newProduct,
          retailSetupFee = _this$props$newProduc4.retailSetupFee,
          setupSliderRatio = _this$props$newProduc4.setupSliderRatio;

      var _this$props$doFeeCalc4 = _this.props.doFeeCalculations(retailSetupFee, setupSliderRatio),
          likeablelocalAmount = _this$props$doFeeCalc4.likeablelocalAmount;

      _this.props.editProductField('setupFeeApplicationFee', likeablelocalAmount);
    });

    return _this;
  }

  _createClass(NewProductForm, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.clearForm();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          invalidFields = _this$props.invalidFields,
          newProduct = _this$props.newProduct;
      var errorText = 'This is a required field.';
      var _this$props$newProduc5 = this.props.newProduct,
          retailMonthlyPrice = _this$props$newProduc5.retailMonthlyPrice,
          retailSetupFee = _this$props$newProduc5.retailSetupFee,
          setupSliderRatio = _this$props$newProduc5.setupSliderRatio,
          monthlySliderRatio = _this$props$newProduc5.monthlySliderRatio;
      var _ref = [this.props.doFeeCalculations(retailMonthlyPrice, monthlySliderRatio), this.props.doFeeCalculations(retailSetupFee, setupSliderRatio)],
          _ref$ = _ref[0],
          monthlyLLAmount = _ref$.likeablelocalAmount,
          monthlyPartnerAmount = _ref$.partnerAmount,
          monthlyTotal = _ref$.total,
          monthlyTransactionFee = _ref$.transactionFee,
          _ref$2 = _ref[1],
          setupLLAmount = _ref$2.likeablelocalAmount,
          setupPartnerAmount = _ref$2.partnerAmount,
          setupTotal = _ref$2.total,
          setupTransactionFee = _ref$2.transactionFee;
      /*
      * END MONTHLY FEE LOGIC
      */

      return /*#__PURE__*/React.createElement("div", null, newProduct && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }), /*#__PURE__*/React.createElement(Popover, {
        open: this.state.monthlyEntryPopover,
        anchorEl: this.state.monthlyPopoverAnchor,
        anchorOrigin: {
          horizontal: 'left',
          vertical: 'top'
        },
        targetOrigin: {
          horizontal: 'left',
          vertical: 'top'
        },
        onRequestClose: function onRequestClose() {
          _this2.setState({
            monthlyEntryPopover: false,
            monthlyPopoverAnchor: null,
            monthlyPopoverData: {}
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          margin: 5
        }
      }, this.state.monthlyEntryPopover ? function () {
        return /*#__PURE__*/React.createElement(TextField, {
          autofocus: true,
          defaultValue: _.round(_this2.state.monthlyPopoverData.defaultValue, 2),
          onChange: function onChange(_ref2) {
            var value = _ref2.target.value;
            var retailPrice = _this2.props.newProduct.retailMonthlyPrice; // prevent UI glitches

            if (value === '' || parseFloat(value) > retailPrice) {
              return false;
            }

            var number = parseFloat("".concat(value).replace('$', ''));

            if (_this2.state.monthlyPopoverData.type === 'partner') {
              number += monthlyTransactionFee;
            }

            number = Math.max(0, number);
            var percent = number / parseFloat(retailPrice);

            if (_this2.state.monthlyPopoverData.type === 'partner') {
              percent = 1.0 - percent;
            }

            _this2.props.editProductField(_this2.state.monthlyPopoverData.ratioKey, percent);
          },
          type: "number"
        });
      }() : null)), /*#__PURE__*/React.createElement(Popover, {
        open: this.state.setupEntryPopover,
        anchorEl: this.state.setupPopoverAnchor,
        anchorOrigin: {
          horizontal: 'left',
          vertical: 'top'
        },
        targetOrigin: {
          horizontal: 'left',
          vertical: 'top'
        },
        onRequestClose: function onRequestClose() {
          _this2.setState({
            setupEntryPopover: false,
            setupPopoverAnchor: null,
            setupPopoverData: {}
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          margin: 5
        }
      }, this.state.setupEntryPopover ? function () {
        return /*#__PURE__*/React.createElement(TextField, {
          autofocus: true,
          defaultValue: _.round(_this2.state.setupPopoverData.defaultValue, 2),
          onChange: function onChange(_ref3) {
            var value = _ref3.target.value;

            if (value === '' || parseFloat(value) > retailSetupFee) {
              return false;
            }

            var retailPrice = _this2.props.newProduct.retailSetupFee;
            var number = parseFloat("".concat(value).replace('$', ''));

            if (_this2.state.setupPopoverData.type === 'partner') {
              number += setupTransactionFee;
            }

            number = Math.max(0, number);
            var percent = number / parseFloat(retailPrice);

            if (_this2.state.setupPopoverData.type === 'partner') {
              percent = 1.0 - percent;
            }

            _this2.props.editProductField(_this2.state.setupPopoverData.ratioKey, percent);
          },
          type: "number"
        });
      }() : null)), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          marginTop: 8,
          justifyContent: 'space-around'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          flex: '0 0 45%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          border: '1px solid rgb(224,224,224)',
          borderRadius: 2
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 24,
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement(TextField, {
        className: styles.textField,
        errorText: invalidFields.includes('title') ? errorText : null,
        floatingLabelText: "Title",
        value: newProduct.title,
        onChange: this.handleTextFieldChange,
        id: "title",
        style: {
          width: '100%'
        }
      }), /*#__PURE__*/React.createElement(TextField, {
        className: styles.textField,
        errorText: invalidFields.includes('description') ? errorText : null,
        floatingLabelText: "Description",
        value: newProduct.description,
        onChange: this.handleTextFieldChange,
        id: "description",
        style: {
          width: '100%'
        }
      }), /*#__PURE__*/React.createElement("div", null, !invalidFields.includes('retailMonthlyPrice') && /*#__PURE__*/React.createElement("span", {
        style: {
          color: '#000000',
          marginRight: 4
        }
      }, "$"), /*#__PURE__*/React.createElement(TextField, {
        className: styles.textField,
        errorText: invalidFields.includes('retailMonthlyPrice') ? errorText : null,
        floatingLabelText: "Monthly Fee",
        value: newProduct.retailMonthlyPrice,
        onChange: this.handleTextFieldChange,
        id: "retailMonthlyPrice",
        type: "number"
      })), /*#__PURE__*/React.createElement("div", null, !invalidFields.includes('adsBudget') && /*#__PURE__*/React.createElement("span", {
        style: {
          color: '#000000',
          marginRight: 4
        }
      }, "$"), /*#__PURE__*/React.createElement(TextField, {
        className: styles.textField,
        errorText: invalidFields.includes('adsBudget') ? errorText : null,
        floatingLabelText: "Monthly Ads Budget",
        value: newProduct.adsBudget,
        onChange: this.handleTextFieldChange,
        id: "adsBudget",
        type: "number"
      })), /*#__PURE__*/React.createElement("div", null, !invalidFields.includes('retailSetupFee') && /*#__PURE__*/React.createElement("span", {
        style: {
          color: '#000000',
          marginRight: 4
        }
      }, "$"), /*#__PURE__*/React.createElement(TextField, {
        className: styles.textField,
        errorText: invalidFields.includes('retailSetupFee') ? errorText : null,
        floatingLabelText: "One Time Setup Fee",
        value: newProduct.retailSetupFee,
        onChange: this.handleTextFieldChange,
        id: "retailSetupFee",
        type: "number"
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 16,
          padding: 24,
          paddingLeft: 28,
          borderTop: '1px solid rgb(224,224,224)',
          color: '#333333',
          fontSize: 18,
          fontWeight: 300
        }
      }, "Total Monthly Package Price:", /*#__PURE__*/React.createElement("span", {
        style: {
          color: '#000000',
          "float": 'right',
          fontSize: 18,
          fontWeight: 700
        }
      }, this.formatCurrency(parseFloat(newProduct.retailMonthlyPrice) + parseFloat(newProduct.adsBudget)))), newProduct.retailSetupFee > 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 24,
          paddingLeft: 28,
          paddingTop: 0,
          color: '#333333',
          fontSize: 18,
          fontWeight: 300
        }
      }, "One Time Setup Fee", /*#__PURE__*/React.createElement("span", {
        style: {
          color: '#000000',
          "float": 'right',
          fontSize: 18,
          fontWeight: 700
        }
      }, this.formatCurrency(newProduct.retailSetupFee))))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          flex: '0 0 45%'
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 16,
          color: 'rgb(51,51,51)'
        }
      }, "Monthly Fee Distribution"), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '1',
          display: 'flex',
          justifyContent: 'space-around',
          position: 'relative',
          top: 14
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#777',
          flex: '0 0 100px',
          fontSize: 13,
          textAlign: 'left'
        }
      }, "Partner"), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '1',
          paddingLeft: 12,
          paddingRight: 12
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#777',
          flex: '0 0 100px',
          fontSize: 13,
          textAlign: 'right'
        }
      }, "Likeable Local")), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '1',
          display: 'flex',
          justifyContent: 'space-around'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#333',
          flex: '0 0 50px',
          paddingTop: 24
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.fakeTextField,
        style: {
          width: 80
        },
        name: "monthlyPartnerEntry",
        onClick: function onClick(e) {
          _this2.setState({
            monthlyEntryPopover: !_this2.state.monthlyEntryPopover,
            monthlyPopoverAnchor: e.target,
            monthlyPopoverData: {
              type: 'partner',
              ratioKey: 'monthlySliderRatio',
              defaultValue: monthlyPartnerAmount
            }
          });
        }
      }, this.formatCurrency(monthlyPartnerAmount))), /*#__PURE__*/React.createElement(Slider, {
        style: {
          marginTop: 13,
          flex: '1',
          paddingLeft: 12,
          paddingRight: 12
        },
        min: 0,
        max: 1,
        step: 0.0001,
        onDragStop: this.handleMonthlySliderDrop,
        value: this.props.newProduct.monthlySliderRatio,
        onChange: function onChange(e, val) {
          _this2.props.editProductField('monthlySliderRatio', val);
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#333',
          flex: '0 0 50px',
          paddingTop: 24
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.fakeTextField,
        name: "monthlyLikeableEntry",
        style: {
          width: 80
        },
        onClick: function onClick(e) {
          _this2.setState({
            monthlyEntryPopover: !_this2.state.monthlyEntryPopover,
            monthlyPopoverAnchor: e.target,
            monthlyPopoverData: {
              type: 'likeablelocal',
              ratioKey: 'monthlySliderRatio',
              defaultValue: monthlyLLAmount
            }
          });
        }
      }, this.formatCurrency(monthlyLLAmount))))), setupTotal > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 16,
          color: 'rgb(51,51,51)'
        }
      }, "Setup Fee Distribution"), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '1',
          display: 'flex',
          justifyContent: 'space-around',
          position: 'relative',
          top: 14
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#777',
          flex: '0 0 100px',
          fontSize: 13,
          textAlign: 'left'
        }
      }, "Partner"), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '1',
          paddingLeft: 12,
          paddingRight: 12
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#777',
          flex: '0 0 100px',
          fontSize: 13,
          textAlign: 'right'
        }
      }, "Likeable Local")), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '1',
          display: 'flex',
          justifyContent: 'space-around'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#333',
          flex: '0 0 50px',
          paddingTop: 24
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.fakeTextField,
        style: {
          width: 80
        },
        name: "monthlyPartnerEntry",
        onClick: function onClick(e) {
          _this2.setState({
            setupEntryPopover: !_this2.state.setupEntryPopover,
            setupPopoverAnchor: e.target,
            setupPopoverData: {
              type: 'partner',
              ratioKey: 'setupSliderRatio',
              defaultValue: setupPartnerAmount
            }
          });
        }
      }, this.formatCurrency(setupPartnerAmount))), /*#__PURE__*/React.createElement(Slider, {
        style: {
          flex: '1',
          paddingLeft: 12,
          paddingRight: 12
        },
        min: 0,
        max: 1,
        step: 0.0001,
        value: this.props.newProduct.setupSliderRatio,
        onChange: function onChange(e, val) {
          _this2.props.editProductField('setupSliderRatio', val);
        },
        onDragStop: this.handleSetupSliderDrop
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#333',
          flex: '0 0 50px',
          paddingTop: 24
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.fakeTextField,
        style: {
          width: 80
        },
        name: "monthlyPartnerEntry",
        onClick: function onClick(e) {
          _this2.setState({
            setupEntryPopover: !_this2.state.setupEntryPopover,
            setupPopoverAnchor: e.target,
            setupPopoverData: {
              type: 'likeablelocal',
              ratioKey: 'setupSliderRatio',
              defaultValue: setupLLAmount
            }
          });
        }
      }, this.formatCurrency(setupLLAmount)))))))));
    }
  }]);

  return NewProductForm;
}(Component)) || _class);
export { NewProductForm as default };